<template>
    <Page v-if="isUserInGroup('merchant')" :header="(!isPWA && !isTgApp) ? header[lang].title : ''" type="gray">
        <template v-slot:body>
            <MobMenu :items="menu" />
        </template> 
    </Page>
    <Page v-else type="gray">
        <template v-slot:body>
            <Be />
        </template> 
    </Page>
</template>

<script>
import Connect          from '@/assets/js/Connect'
import Helper           from '@/assets/js/Helper'
import Page             from '@/components/sides/Page.vue' 
import Be               from '@/components/merchant/Be.vue'
import MobMenu          from '@/components/sides/menu/MobMenu.vue'
import { mapActions }   from 'vuex'

export default {
    data() {
        return {
            header: {
                en: {title: "Trade"} ,
                ru: {title: "Обмен и выплаты"} ,
            }, 
            merchant: null,
            loading: false,
            menu: [
                {
                    href: '/merchant/stat/',
                    label: {
                        ru: 'Статистика',
                        en: 'Statistics'
                    },
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/merchant/transfers/',
                    label: {
                        ru: 'Переводы клиентов',
                        en: 'Client transfers'
                    },
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/personal/wallets/',
                    label: {
                        ru: 'Кошелек',
                        en: 'Wallet'
                    },
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/merchant/rates/',
                    label: {
                        ru: 'Курсы',
                        en: 'Courses'
                    },
                    btnIcon: 'pi pi-angle-right'
                }
            ]
        }
    },
    components: {
        Page,
        Be,
        MobMenu
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        goTo(url) {
            if(!url) return
            this.$router.push({path: url})
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}
</script>